import { api } from "./client";

/**
 * Types + client for the Director Dashboard team rollup
 * (GET /api/v1/me/team-rollup). Mirrors the API Zod schema in
 * packages/api/src/schemas/summary.ts (teamRollupResponseSchema).
 */

export interface RollupUser {
  id: string;
  name: string;
  email: string;
  avatarUrl: string | null;
}

export interface RollupEpic {
  id: string;
  identifier: string | null;
  name: string;
}

export interface RollupFeature {
  id: string;
  identifier: string;
  title: string;
  epicId: string;
  epicName: string;
  epicIdentifier: string | null;
  status: string | null;
  statusCategory: string | null;
  percentComplete: number | null;
  blocked: boolean;
}

export interface MemberProgress {
  totalAssigned: number;
  completed: number;
  inProgress: number;
  blocked: number;
  percentComplete: number;
}

/** One of a member's computers (new look Team board). */
export interface RollupMachine {
  id: string;
  name: string;
  readiness: "ready" | "runtime-not-found" | "offline";
  /** Running a job right now. */
  busy: boolean;
}

export interface TeamRollupMember {
  user: RollupUser;
  activeEpics: RollupEpic[];
  activeFeatures: RollupFeature[];
  progress: MemberProgress;
  /** Absent from APIs older than the new look's Team board. */
  machines?: RollupMachine[];
}

export interface TeamRollupResponse {
  organizationId: string | null;
  scopeTeamId: string | null;
  memberCount: number;
  members: TeamRollupMember[];
  generatedAt: string;
}

export const teamRollupApi = {
  /**
   * Fetch the org-wide per-person plan-vs-progress rollup. Pass a `teamId`
   * to scope to that team and all of its descendants (the manager's subtree).
   */
  get: async (teamId?: string): Promise<TeamRollupResponse> => {
    const query = teamId ? `?teamId=${encodeURIComponent(teamId)}` : "";
    const res = await api.get<{ data: TeamRollupResponse }>(`/me/team-rollup${query}`);
    return res.data;
  },
};
